export enum InterfaceTypeEnum {
  API = 'API',
  SFTP = 'SFTP',
  EMAIL = 'EMAIL',
  S3 = 'S3'
}
